import { ChangeDetectionStrategy, Component, SimpleChanges, input, signal } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ErrorMessagesType } from '../../../core/models/error-message.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-validation-feedback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './validation-feedback.component.html',
  styleUrl: './validation-feedback.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationFeedbackComponent {
  errors = input.required<ValidationErrors | null>();

  control = input.required<AbstractControl>();

  patternMessage = input<string | null>();

  message = signal<string | undefined | null>('');

  ngOnChanges({ errors }: SimpleChanges): void {
    if (errors) {
      this.message.set(this.errorMessage());
    }
  }

  private errorMessage() {
    for (const propertyName in this.errors()) {
      if (propertyName in this.errors()!) {
        return this.getErrorMessage(propertyName, this.errors()![propertyName]);
      }
    }

    return null;
  }

  private getErrorMessage(validatorName: string, validatorValue?: ValidationErrors) {
    if (validatorValue && typeof validatorValue === 'object' && 'message' in validatorValue && validatorValue['message']) {
      return validatorValue['message'] as string;
    }

    const errorMessages = {
      required: 'This field is required',
      minlength: `Minimum of ${validatorValue?.['requiredLength']} characters`,
      maxlength: `Maximum of ${validatorValue?.['requiredLength']} characters`,
      email: 'Invalid email format',
      invalidEmail: validatorValue?.['message'] || 'Invalid email format',
      passwordMismatch: 'Passwords do not match!',
      pattern: this.patternMessage(),
      dobInFuture: 'Date of birth cannot be in the future.',
      whitespace: 'This field cannot contain only spaces',
      effectiveDateInPast: 'The effective date cannot be in the past.',
      effectiveDateTooEarly: 'The selected effective date is too early.',
      effectiveDateTooFarInFuture: 'The effective date cannot be more than 60 days in the future.',
    };

    return errorMessages[validatorName as ErrorMessagesType];
  }
}
